const cookieName = "cookieAccepted";

document.addEventListener("DOMContentLoaded", () => {
  const cookiePopup = document.querySelector(".cookie");
  if (!cookiePopup || getCookie(cookieName)) {
    return
  }
  setTimeout(() => {
    cookiePopup.classList.add("cookie--visible");
  }, 1000)
  const accept = cookiePopup.querySelector(".cookie-buttons__button--accept");
  const decline = cookiePopup.querySelector(".cookie-buttons__button--decline");
  const close = cookiePopup.querySelector(".cookie-close");
  if (accept) {
    accept.addEventListener("click", () => {
      setCookie(cookieName, "true");
      cookiePopup.classList.remove("cookie--visible");
    });
  }
  if (decline) {
    decline.addEventListener("click", () => {
      setCookie(cookieName, "false");
      cookiePopup.classList.remove("cookie--visible");
    });
  }
  if (close) {
    close.addEventListener("click", () => {
      cookiePopup.classList.remove("cookie--visible");
    });
  }
})

const getCookie = (name) => {
  const value = " " + document.cookie;
  const parts = value.split(" " + name + "=");
  return parts.length < 2 ? undefined : parts.pop().split(";").shift();
};

const setCookie = function (name, value, expiryDays, domain, path, secure) {
  const exdate = new Date();
  exdate.setHours(
    exdate.getHours() +
    (typeof expiryDays !== "number" ? 365 : expiryDays) * 24
  );
  document.cookie =
    name +
    "=" +
    value +
    ";expires=" +
    exdate.toUTCString() +
    ";path=" +
    (path || "/") +
    (domain ? ";domain=" + domain : "") +
    (secure ? ";secure" : "");
};